import { css } from '@stitches/react'
import React, { SVGProps } from 'react'

type GraphicsProps = SVGProps<SVGElement>

export const Graphics = (props: GraphicsProps) => (
  /* @ts-ignore */
  <svg
    width="90"
    height="45"
    viewBox="0 0 90 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="90" y="45" width="45" height="15" transform="rotate(-180 90 45)" fill="#E7B536" />
    <rect x="45" y="30" width="45" height="15" transform="rotate(-180 45 30)" fill="#F43E72" />
    <rect x="90" y="15" width="45" height="15" transform="rotate(-180 90 15)" fill="#4791FF" />
  </svg>
)

export const topGraphics = css({
  position: 'absolute',
  top: '32px',
  right: '0px'
})
